/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * UsersIcon
 */
export default class UsersIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M13 14H5c-2.8 0-5 2.2-5 5v2c0 .6.4 1 1 1s1-.4 1-1v-2c0-1.7 1.3-3 3-3h8c1.7 0 3 1.3 3 3v2c0 .6.4 1 1 1s1-.4 1-1v-2c0-2.8-2.2-5-5-5zM9 12c2.8 0 5-2.2 5-5s-2.2-5-5-5-5 2.2-5 5 2.2 5 5 5zm0-8c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zM20.3 14.1c-.5-.1-1.1.2-1.2.7-.1.5.2 1.1.7 1.2 1.4.4 2.3 1.6 2.3 2.9v2c0 .6.4 1 1 1s1-.4 1-1v-2c-.1-2.2-1.6-4.2-3.8-4.8zM16.2 2.1c-.5-.1-1 .2-1.2.8-.1.5.2 1.1.7 1.2 1.6.4 2.5 2 2.2 3.7-.3 1.1-1.2 1.9-2.2 2.2-.5.2-.8.7-.7 1.2.1.4.5.7 1 .7h.3c1.7-.5 3.1-1.9 3.6-3.6.6-2.8-1-5.5-3.7-6.2z"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

